var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "clock (13)",
    d: "M8 0a8 8 0 108 8 8.009 8.009 0 00-8-8zm3.8 12.138a.666.666 0 01-.943 0L7.529 8.8a.664.664 0 01-.2-.471V4a.667.667 0 111.338 0v4.057L11.8 11.2a.666.666 0 010 .943zm0 0",
    fill: "inherit"
  })));
}

export default SvgClock;